export default {
  title_serviceCertification1: '交易额度提升流程隐私政策',
  serviceCertification2:
    'BluePay Company Limited（以下简称“公司”）高度重视客户及用户（以下合称“您”）的隐私及个人信息保护。为确保在信用额度提升流程中您的个人信息得到妥善保护，公司制定了本隐私政策，以使您能够放心使用通过BluePay应用程序（以下简称“应用程序”）提供的电子货币服务、支付服务、通过电子方式提供的汇款服务以及其他经泰国银行批准的当前及未来可能提供的服务（包括但不限于与公司提供的应用程序、网站及其他渠道使用相关的任何服务，以下合称“服务”）。本隐私政策特别详细说明了交易额度提升流程中的隐私保护。请您仔细阅读并理解本隐私政策的内容。通过进行交易额度提升操作，即视为您已阅读、理解并同意本隐私政策的所有条款。',
  title_serviceCertification3: '个人信息',
  serviceCertification4:
    '“个人信息”是指与个人相关的信息，能够直接或间接识别该个人，但不包括已故人员的特定信息，如姓名、身份证号、地址、电话号码、金融交易记录等。',
  serviceCertification5:
    '个人信息可能包含敏感信息，存在被不公平对待的风险（以下简称“敏感个人信息”），例如生物识别数据、宗教相关数据等。',
  serviceCertification6: '在此情况下，个人信息包括您向公司提供的任何信息、公司持有或依法从其他来源或他人处收集的信息。',
  serviceCertification7:
    '如果公司出于本隐私政策规定范围之外的目的需要收集、使用或披露您的个人信息，公司将在收集、使用或披露您的个人信息之前或之时，告知您该等不同的特征。',
  title_serviceCertification8: '公司收集、使用或披露的个人信息类型',
  serviceCertification9: '在信用额度提升流程中，公司将收集以下个人信息：',
  serviceCertification10: '身份信息：您上传的身份证图像，包括身份证上的姓名、身份证号码、照片、地址及其他信息。',
  serviceCertification11: '生物识别信息：您进行活体检测时生成的人脸识别数据。',
  serviceCertification12: '金融信息: 您的BluePay账户中的交易历史及其他相关金融信息。',
  serviceCertification13:
    '设备、系统及使用行为相关信息:包括但不限于与网络连接相关的设备身份号码（如IP地址、MAC地址、设备ID）、广告ID、移动设备操作系统、移动网络服务提供商、位置、设备使用详情、cookies、电话簿、应用程序使用情况、技术信息、设备的型号及类型、照片、图像及相册等。',
  serviceCertification14:
    '除上述基本服务外，如公司出于提供额外服务的需要，或出于收集、使用、披露敏感个人信息的目的，公司将仅在法律规定的合法基础上进行处理。在此情况下，公司将在处理之前或之时，告知您需要收集、使用或披露的个人信息的目的和类型。',
  title_serviceCertification15: '收集、使用和披露您个人信息的法律依据及处理目的',
  serviceCertification16: '公司将在法律依据下，并按照以下目的收集、使用或披露您的个人信息：',
  title_serviceCertification17: '（一）履行合同的必要性',
  serviceCertification18:
    '- 信用额度提升评估：公司将使用收集的个人信息评估您是否有资格提升信用额度。这包括验证您的身份、评估您的金融历史，并根据您的个人资料确定适当的信用额度；',
  serviceCertification19:
    '- 与内政部（DOPA）进行验证：为确保您的身份信息的准确性和真实性，公司将在获得您明确同意的情况下，将您的个人信息发送至内政部（DOPA）进行验证。这一步骤对于确认您的身份和信用额度提升资格至关重要；',
  serviceCertification20: '- 提供公司最佳服务的其他必要事项；',
  serviceCertification21: '- 提供支持服务，联系及请求信息，接受请求，接收新闻或查询服务；',
  serviceCertification22: '- 提高服务质量和效率，方便您使用服务；',
  serviceCertification23: '- 处理数据以提供服务；',
  serviceCertification24: '- 通过您向公司提供的应用程序或联系方式，向您通知可能符合您利益或使您受益的服务；',
  serviceCertification25: '- 与服务相关的其他处理，可能使您受益。',
  title_serviceCertification26: '（二）遵守法律义务',
  serviceCertification27:
    '- 遵守公司所受制于的相关法律，包括遵守法律、法规、规则、行为准则或由主管部门或监管机构发布的指南，如泰国银行的通知、反洗钱法等。在此情况下，公司可能会将您的个人信息转移给内部/外部审计师、政府机构或其他相关法人实体。',
  title_serviceCertification28: '（三）基于您的同意',
  serviceCertification29:
    '- 分析或预测您的偏好或行为，包括进行研究、开发、产品改进和市场营销策略，以便向您提供经过分析和选择的产品和服务、特权、促销活动或建议；',
  serviceCertification30: '- 公司不时获得您同意的其他合法目的，例如通过应用程序方便您使用其他服务提供商的服务。',
  title_serviceCertification31: '（四）公司或其他公司的合法利益',
  serviceCertification32: '- 预防犯罪和欺诈；',
  serviceCertification33: '- 使安全系统和网络达到国际标准；',
  serviceCertification34: '- BluePay账户的欺诈预防和安全管理。',
  title_serviceCertification35: '（五）重大公共利益',
  serviceCertification36: '- 为预防犯罪和欺诈进行身份识别/验证；',
  serviceCertification37: '- 怀疑金融交易支持恐怖主义或洗钱行为。',
  serviceCertification38:
    '除上述法律依据和目的外，公司可能会根据其他法律依据收集、使用或披露您的个人信息，例如防止或抑制对您的生命、身体或健康的危险，或为实现与准备历史文件或公共利益档案相关的目的。如果收集、使用或披露属于上述其他目的，公司将在之后通知您。',
  title_serviceCertification39: '向第三方披露您的个人信息及从其他来源收集个人信息',
  serviceCertification40:
    '您的个人信息仅在公司内部用于上述目的。除非为实现上述法律依据下的处理目的，公司可能会从以下人员处收集和/或使用、发送、转移、处理和/或披露个人信息：',
  serviceCertification41: '对公司具有控制权或受公司控制的法人实体，包括受同一控制的其他公司；',
  serviceCertification42:
    '公司为合同方或与公司具有法律关系的其他法人实体或个人，包括有权决定对您的个人信息采取任何行动的其他服务提供商，无论是在国内还是国外，例如外部服务提供商、云服务提供商或公司的其他业务合作伙伴。在此情况下，公司应确保这些服务提供商将按照本隐私政策和适用法律处理您的个人信息；',
  serviceCertification43:
    '公司的审计师、外部审查员、政府机构、债权转让人以及公司为遵守法律而必须转移个人信息的任何其他个人或法人实体；',
  serviceCertification44: '在公司合并、转让、出售其资产和/或业务（无论是全部还是部分）的情况下，业务/企业的受让人。',
  title_serviceCertification45: '个人信息的保留期限',
  serviceCertification46:
    '公司将在提供服务所必需的期限内保留您的个人信息，或者在您与公司之间合同或法律关系所规定的期限内保留，以实现上述目的。除非适用法律或法规要求公司遵守，或者为遵守公司内部实践、法律索赔或监管机构的要求，个人信息可能会被进一步保留一段合理且必要的期限，以满足每类个人信息的需要。',
  serviceCertification47:
    '当超过保留期限，或者公司没有权利或没有其他法律依据允许公司处理您的个人信息时，公司将按照公司的数据销毁标准，对个人信息进行擦除、销毁或匿名化处理，使其成为无法识别数据主体的匿名数据。',
  title_serviceCertification48: '您根据《个人数据保护法》（B.E. 2562）（以下简称“PDPA”）所享有的法律权利',
  serviceCertification49: '作为PDPA下的数据主体，您享有以下法律权利：',
  title_serviceCertification50: '（一）撤回同意的权利',
  serviceCertification51: '您有权在公司持有您的个人信息期间，撤回您之前向公司提供的关于处理个人信息的同意。',
  title_serviceCertification52: '（二）访问和获取个人信息副本的权利',
  serviceCertification53:
    '您有权要求访问您提供给公司的个人信息，或者以可读或通常用于自动工具或设备的格式获取该个人信息的副本（如果公司提供），或者要求公司向其他数据控制者发送或转移此类个人信息（除非由于技术原因无法做到），包括要求披露未经您同意而获得的个人信息的获取情况。',
  title_serviceCertification54: '（三）更正个人信息的权利',
  serviceCertification55:
    '您有权要求公司在持有您的个人信息期间，更正您提供给公司的任何不准确的个人信息，或者补充任何数据。',
  title_serviceCertification56: '（四）擦除、销毁或匿名化个人信息的权利',
  serviceCertification57:
    '您有权要求公司将您提供给公司的个人信息擦除、销毁，或者匿名化处理，使其成为无法识别数据主体的匿名数据。',
  title_serviceCertification58: '（五）限制使用个人信息的权利',
  serviceCertification59: '您有权要求公司在法律规定的某些情况下，限制使用您提供给公司的个人信息。',
  title_serviceCertification60: '（六）反对处理个人信息的权利',
  serviceCertification61: '您有权在法律规定的某些情况下，反对公司处理您提供给公司的个人信息。',
  title_serviceCertification62: '（七）向PDPA违规行为提出投诉的权利',
  serviceCertification63: '如果公司（包括其员工或承包商）违反或未遵守PDPA，您有权向个人数据保护委员会提出投诉。',
  serviceCertification64:
    '在此情况下，您可以通过电子邮件将您的请求发送至公司的数据保护办公室，以行使上述权利。公司将在PDPA规定的合理时间内，尽最大努力按照您的请求进行处理。此外，公司会通知您处理该请求可能产生的影响。然而，如果存在特定的法律依据允许公司这样做，公司有权拒绝您的任何请求。此外，根据行政成本和公司内部政策，公司保留向您收取处理您的请求所产生费用的权利。',
  title_serviceCertification65: '安全性',
  serviceCertification66:
    '公司深知您的个人信息的重要性。因此，公司不断改进和开发符合法律要求、与国际安全标准保持一致的个人信息安全系统。公司会尽最大努力遵守本隐私政策，并督促公司人员（包括数据处理者）遵守并尊重您的个人信息安全，他们有权访问个人信息或承担法律责任。',
  serviceCertification67:
    '如果公司需要将您的个人信息转移到国外，公司将遵守个人数据保护法律规定的标准。此外，公司不会将您的个人信息转移到不符合法律规定标准的国家，除非您同意公司将您的个人信息发送或转移到该目的地国家。然而，如果由于计算机间谍活动（如黑客攻击、盗窃、复制或破坏数据库、破坏个人密码或其他方法）导致您的个人信息被盗，且非公司过错，在这种情况下，公司有权免除由此行为产生的任何责任。',
  title_serviceCertification68: '无完全法律行为能力人的个人信息',
  serviceCertification69:
    '如果您被视为无完全法律行为能力人，包括未成年人（年龄低于20岁或非完全行为能力人）、被法院判定为限制行为能力人或无行为能力人，在收集、使用或披露您的个人信息时，公司将仅按照法律规定程序和标准进行。',
  title_serviceCertification70: '政策的改进',
  serviceCertification71:
    '使用公司的任何服务，即视为接受本隐私政策。公司可能会随时对本隐私政策进行修改，并通知您该修改。在通知修改后继续使用应用程序或任何服务，将被视为接受每次的修改。',
  title_serviceCertification72: '联系方式',
  serviceCertification73:
    '如果您对本隐私政策有任何疑问、投诉、访问请求，或希望查看公司持有的任何提供的个人信息，您可以通过以下方式联系我们：',
  serviceCertification74: 'BluePay Company Limited',
  serviceCertification75:
    '地址 : BluePay Company Limited，319 Chamchuri Square, 24th Floor, Room No.24072, Phaya Thai Road, Pathum Wan Sup-district, Pathum Wan District, Bangkok 10330',
  serviceCertification76: '邮箱: csr@bluepay.asia',
  serviceCertification77: '联系方式: 099-6843458'
}
